import React from "react";
import { FiLinkedin } from "react-icons/fi";
import ScrollAnimation from "react-animate-on-scroll";

const teamData = [
  {
    image: "Amy",
    name: "Amy Fox",
    designation: "CEO - Co-Founder",
    location: "Washington DC",
    socialNetwork: [
      {
        icon: <FiLinkedin />,
        url: "https://www.linkedin.com/in/amy-fox-32a83518/",
      },
    ],
  },
  {
    image: "Charlie",
    name: "Charlie Egan",
    designation: "CIO - Co-Founder",
    location: "Chicago",

    socialNetwork: [
      {
        icon: <FiLinkedin />,
        url: "https://www.linkedin.com/in/mcharlesegan/",
      },
    ],
  },
  {
    image: "dimitar",
    name: "Dimitar Stoyanov",
    designation: "CTO - Co-Founder",
    location: "London",
    socialNetwork: [
      {
        icon: <FiLinkedin />,
        url: "https://www.linkedin.com/in/dimitar-stoyanov-688a0073/",
      },
    ],
  },
];

const TeamOne = ({ column, teamStyle }) => {
  return (
    <div className="row row--15">
      {teamData.map((data, index) => (
        <div className={`${column}`} key={index}>
          <div className={`rn-team ${teamStyle}`}>
            <ScrollAnimation
              animateIn="fadeInUp"
              animateOut="fadeInOut"
              animateOnce={true}
            >
              <div className="inner">
                <figure className="thumbnail">
                  <img
                    src={`./images/team/${data.image}.png`}
                    alt="Corporate React Template"
                  />
                </figure>
                <figcaption className="content">
                  <h2 className="title">{data.name}</h2>
                  <h6 className="subtitle theme-gradient">
                    {data.designation}
                  </h6>
                  <span className="team-form">
                    <img
                      src="./images/team/location.svg"
                      alt="Corporate React Template"
                    />
                    <span className="location">{data.location}</span>
                  </span>
                  <p className="description">{data.description}</p>

                  <ul className="social-icon social-default icon-naked mt--20">
                    {data.socialNetwork.map((social, index) => (
                      <li key={index}>
                        <a href={`${social.url}`}>{social.icon}</a>
                      </li>
                    ))}
                  </ul>
                </figcaption>
              </div>
            </ScrollAnimation>
          </div>
        </div>
      ))}
    </div>
  );
};

export default TeamOne;
